import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-600" }, "Simple Table", -1)
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "my-6 overflow-hidden bg-white rounded-md shadow" }
const _hoisted_5 = { class: "w-full text-left border-collapse" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "border-b" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-sm font-medium text-gray-100 uppercase bg-indigo-800" }, " City "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-sm font-medium text-gray-100 uppercase bg-indigo-800" }, " Total orders ")
  ])
], -1)
const _hoisted_7 = { class: "px-6 py-4 text-lg text-gray-700 border-b" }
const _hoisted_8 = { class: "px-6 py-4 text-gray-500 border-b" }
const _hoisted_9 = { class: "mt-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-600" }, "Table with pagination", -1)
const _hoisted_11 = { class: "mt-6" }
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<h2 class=\"text-xl font-semibold leading-tight text-gray-700\">Users</h2><div class=\"flex flex-col mt-3 sm:flex-row\"><div class=\"flex\"><div class=\"relative\"><select class=\"block w-full h-full px-4 py-2 pr-8 leading-tight text-gray-700 bg-white border border-gray-400 rounded-l appearance-none focus:outline-none focus:bg-white focus:border-gray-500\"><option>5</option><option>10</option><option>20</option></select><div class=\"absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none\"><svg class=\"w-4 h-4 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z\"></path></svg></div></div><div class=\"relative\"><select class=\"block w-full h-full px-4 py-2 pr-8 leading-tight text-gray-700 bg-white border-t border-b border-r border-gray-400 rounded-r appearance-none sm:rounded-r-none sm:border-r-0 focus:outline-none focus:border-l focus:border-r focus:bg-white focus:border-gray-500\"><option>All</option><option>Active</option><option>Inactive</option></select><div class=\"absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 pointer-events-none\"><svg class=\"w-4 h-4 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z\"></path></svg></div></div></div><div class=\"relative block mt-2 sm:mt-0\"><span class=\"absolute inset-y-0 left-0 flex items-center pl-2\"><svg viewBox=\"0 0 24 24\" class=\"w-4 h-4 text-gray-500 fill-current\"><path d=\"M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z\"></path></svg></span><input placeholder=\"Search\" class=\"block w-full py-2 pl-8 pr-6 text-sm text-gray-700 placeholder-gray-400 bg-white border border-b border-gray-400 rounded-l rounded-r appearance-none sm:rounded-l-none focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none\"></div></div>", 2)
const _hoisted_14 = { class: "px-4 py-4 -mx-4 overflow-x-auto sm:-mx-8 sm:px-8" }
const _hoisted_15 = { class: "inline-block min-w-full overflow-hidden rounded-lg shadow" }
const _hoisted_16 = { class: "min-w-full leading-normal" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " User "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Role "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Created at "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-600 uppercase bg-gray-100 border-b-2 border-gray-200" }, " Settings ")
  ])
], -1)
const _hoisted_18 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "flex-shrink-0 w-10 h-10" }
const _hoisted_21 = ["src"]
const _hoisted_22 = { class: "ml-3" }
const _hoisted_23 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_24 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_25 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_26 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_27 = { class: "text-gray-900 whitespace-nowrap" }
const _hoisted_28 = { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }
const _hoisted_29 = { class: "relative" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("td", { class: "px-5 py-5 text-sm bg-white border-b border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-around" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "mx-2 px-2 rounded-md"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5 text-green-700",
          viewBox: "0 0 20 20",
          fill: "currentColor"
        }, [
          /*#__PURE__*/_createElementVNode("path", { d: "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" }),
          /*#__PURE__*/_createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
            "clip-rule": "evenodd"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("form", { method: "POST" }, [
        /*#__PURE__*/_createElementVNode("button", { class: "mx-2 px-2 rounded-md" }, [
          /*#__PURE__*/_createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-5 w-5 text-red-700",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
              "clip-rule": "evenodd"
            })
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col items-center px-5 py-5 bg-white border-t xs:flex-row xs:justify-between\"><span class=\"text-xs text-gray-900 xs:text-sm\">Showing 1 to 4 of 50 Entries</span><div class=\"inline-flex mt-2 xs:mt-0\"><button class=\"px-4 py-2 text-sm font-semibold text-gray-800 bg-gray-300 rounded-l hover:bg-gray-400\"> Prev </button><button class=\"px-4 py-2 text-sm font-semibold text-gray-800 bg-gray-300 rounded-r hover:bg-gray-400\"> Next </button></div></div>", 1)
const _hoisted_32 = { class: "mt-8" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h4", { class: "text-gray-600" }, "Wide Table", -1)
const _hoisted_34 = { class: "flex flex-col mt-6" }
const _hoisted_35 = { class: "py-2 -my-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8" }
const _hoisted_36 = { class: "inline-block min-w-full overflow-hidden align-middle border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_37 = { class: "min-w-full" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase bg-gray-100 border-b border-gray-200" }, " Name "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase bg-gray-100 border-b border-gray-200" }, " Title "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase bg-gray-100 border-b border-gray-200" }, " Status "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase bg-gray-100 border-b border-gray-200" }, " Role "),
    /*#__PURE__*/_createElementVNode("th", { class: "px-6 py-3 bg-gray-100 border-b border-gray-200" })
  ])
], -1)
const _hoisted_39 = { class: "bg-white" }
const _hoisted_40 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_41 = { class: "flex items-center" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 w-10 h-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "w-10 h-10 rounded-full",
    src: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
    alt: "profile pic"
  })
], -1)
const _hoisted_43 = { class: "ml-4" }
const _hoisted_44 = { class: "text-sm font-medium leading-5 text-gray-900" }
const _hoisted_45 = { class: "text-sm leading-5 text-gray-500" }
const _hoisted_46 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_47 = { class: "text-sm leading-5 text-gray-900" }
const _hoisted_48 = { class: "text-sm leading-5 text-gray-500" }
const _hoisted_49 = { class: "px-6 py-4 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_50 = { class: "inline-flex px-2 text-xs font-semibold leading-5 text-green-800 bg-green-100 rounded-full" }
const _hoisted_51 = { class: "px-6 py-4 text-sm leading-5 text-gray-500 border-b border-gray-200 whitespace-nowrap" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("td", { class: "px-6 py-4 text-sm font-medium leading-5 text-right border-b border-gray-200 whitespace-nowrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-around" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-500 flex justify-center" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "#",
        class: "mx-2 px-2 rounded-md"
      }, [
        /*#__PURE__*/_createElementVNode("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          class: "h-5 w-5 text-green-700",
          viewBox: "0 0 20 20",
          fill: "currentColor"
        }, [
          /*#__PURE__*/_createElementVNode("path", { d: "M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" }),
          /*#__PURE__*/_createElementVNode("path", {
            "fill-rule": "evenodd",
            d: "M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z",
            "clip-rule": "evenodd"
          })
        ])
      ]),
      /*#__PURE__*/_createElementVNode("form", { method: "POST" }, [
        /*#__PURE__*/_createElementVNode("button", { class: "mx-2 px-2 rounded-md" }, [
          /*#__PURE__*/_createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "h-5 w-5 text-red-700",
            viewBox: "0 0 20 20",
            fill: "currentColor"
          }, [
            /*#__PURE__*/_createElementVNode("path", {
              "fill-rule": "evenodd",
              d: "M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z",
              "clip-rule": "evenodd"
            })
          ])
        ])
      ])
    ])
  ])
], -1)

import { useTableData } from '../hooks/useTableData'
import Breadcrumb from '../partials/AppBreadcrumb.vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { simpleTableData, paginatedTableData, wideTableData } = useTableData()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Breadcrumb, { breadcrumb: "Tables" }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("table", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(simpleTableData), (i, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: index,
                  class: "hover:bg-gray-200"
                }, [
                  _createElementVNode("td", _hoisted_7, _toDisplayString(i.city), 1),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(i.totalOrders), 1)
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("table", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(paginatedTableData), (u, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("img", {
                            class: "w-full h-full rounded-full",
                            src: u.picture,
                            alt: "profile pic"
                          }, null, 8, _hoisted_21)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("p", _hoisted_23, _toDisplayString(u.name), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_24, [
                      _createElementVNode("p", _hoisted_25, _toDisplayString(u.role), 1)
                    ]),
                    _createElementVNode("td", _hoisted_26, [
                      _createElementVNode("p", _hoisted_27, _toDisplayString(u.created), 1)
                    ]),
                    _createElementVNode("td", _hoisted_28, [
                      _createElementVNode("span", {
                        class: _normalizeClass(`relative inline-block px-3 py-1 font-semibold text-${u.statusColor}-900 leading-tight`)
                      }, [
                        _createElementVNode("span", {
                          "aria-hidden": "",
                          class: _normalizeClass(`absolute inset-0 bg-${u.statusColor}-200 opacity-50 rounded-full`)
                        }, null, 2),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(u.status), 1)
                      ], 2)
                    ]),
                    _hoisted_30
                  ]))
                }), 128))
              ])
            ]),
            _hoisted_31
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _hoisted_33,
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("table", _hoisted_37, [
              _hoisted_38,
              _createElementVNode("tbody", _hoisted_39, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wideTableData), (u, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    _createElementVNode("td", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("div", _hoisted_44, _toDisplayString(u.name), 1),
                          _createElementVNode("div", _hoisted_45, _toDisplayString(u.email), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, _toDisplayString(u.title), 1),
                      _createElementVNode("div", _hoisted_48, _toDisplayString(u.title2), 1)
                    ]),
                    _createElementVNode("td", _hoisted_49, [
                      _createElementVNode("span", _hoisted_50, _toDisplayString(u.status), 1)
                    ]),
                    _createElementVNode("td", _hoisted_51, _toDisplayString(u.role), 1),
                    _hoisted_52
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})